/*
 * @Author: etong
 * @Date: 2023-06-15 13:43:14
 * @LastEditTime: 2025-01-17 17:50:58
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @Description:
 * @FilePath: \oak\src\utils\goodsFile\goodsFile.js
 * Think first, Program later
 */

import {
  GetChangeApplyCurrentFiled,
  GetChangeApplyEditFiled
} from '@/api/product'
import {
  GetBaseData
} from '@/api/common'
// 鼠标移入
export function mouseoverType(str) {
  if (
    Object.keys(this.changeObj).includes(str)
  ) {
    const flag = 'show_' + str
    this[flag] = true
  }
}
// 鼠标离开
export function mouseleaveType(str) {
  const flag = 'show_' + str
  this[flag] = false
}
// 去除当前变更单字段
export function filterObjKeys(obj, keys) {
  return Object.keys(obj).reduce((newData, key) => {
    if (!keys.includes(key)) {
      newData[key] = obj[key]
    }
    return newData
  }, {})
}
// 获取变更字段
export function getChangeApplyCurrentFiled(applyId) {
  return new Promise((resolve, reject) => {
    GetChangeApplyCurrentFiled({
      id: applyId
    }).then(res => {
      if (res.data.res_status_code === '0') {
        if (res.data) {
          resolve(res)
        }
      } else {
        this.$message({
          type: 'error',
          message: res.data.res_message
        })
      }
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取锁定字段
export function getLockInfo(business_id, business_type) {
  return new Promise((resolve, reject) => {
    GetChangeApplyEditFiled({
      business_id,
      business_type
    }).then(res => {
      if (res.data.res_status_code === '0') {
        if (res.data) {
          resolve(res)
        }
      } else {
        this.$message({
          type: 'error',
          message: res.data.res_message
        })
      }
    }).catch(err => {
      reject(err)
    })
  })
}
// 初始化数据，请求接口
export function getMasterBaseData(codetypes) {
  GetBaseData({
    codetypes
  }).then(response => {
    if (response.data.res_status_code === '0') {
      this.baseInfo = {
        ...this.baseInfo,
        ...response.data.res_content
      }
    } else {
      this.$message({
        type: 'error',
        message: response.data.res_message
      })
    }
  })
}
export const objChangeOrderMap = {
  // 每次变更单增加一种新类型单据，这些Map都需要更新
  objQueryName: {
    0: 'GetProductSku',
    1: 'GetProductSPUBill',
    2: 'GetProductSeries',
    3: 'GetBrand',
    4: 'GetProductMaterialMrp',
    5: 'CompanyArchive',
    6: 'GetDepartmentList',
    7: 'GetCostCenterList',
    8: 'GetCompanyBankAccount',
    9: 'Warehouse',
    11: 'GetShop',
    13: 'NewGetProductSku',
    17: 'GetMapleMaterialFactory',
    18: 'GetSellerList',
    19: 'GetAlipayAccountConfigList',
    20: 'GetResearchProjectList',
    21: 'GetAmortizationProjectList',
    22: 'INCIGetList'
  }, // business_type对应queryName
  objModuleKey: {
    0: 'product_list_jjflow',
    1: 'product_spu_jjflow',
    2: 'product_series_jjflow',
    3: 'brand_jjflow',
    4: 'product_material_mrp_jjflow',
    5: 'company_archive_jjflow',
    6: 'department_jjflow',
    7: 'cost_center_jjflow',
    8: 'company_bankaccount_jjflow',
    9: 'warehouse_jjflow',
    11: 'shop_jjflow',
    13: 'product_list_jjflow',
    17: 'maple_material_factory_jjflow',
    18: 'FxSellerJjFlow',
    19: 'alipay_config_jjflow',
    20: 'research_project_jjflow',
    21: 'amortization_project_jjflow',
    22: 'inci_jjflow'
  }, // business_type对应ModuleKey
  objCmtName: {
    0: 'CmtSkuDetail',
    1: 'CmtSpuDetail',
    2: 'CmtProductRangeDetail',
    3: 'CmtBrandDetail',
    4: 'CmtMaterialDetail',
    5: 'Customer',
    6: 'CmtDepartmentDetail',
    7: 'CmtCostCenterDetail',
    8: 'KsBankAccountOverview',
    9: 'WarehouseMasterDataComponent',
    11: 'ShopManagementMasterDataComponent',
    13: 'CmtAuthoritySkuDetail',
    17: 'SkuFactoryRelationshipMasterDataComponent',
    18: 'FxSellerModule',
    19: 'AlipayAccountConfigComponent',
    20: 'ResearchProjectOverview',
    21: 'AmortizationProjectOverview',
    22: 'INCIComponent'
  }, // business_type对应组件名称

  objDocModel: {
    0: 'SKU',
    1: 'ProductSPU',
    2: 'ProductSeries',
    3: 'Brand',
    4: 'ProductMaterialMrp',
    5: 'CompanyArchive',
    6: 'MainDataDepartment',
    7: 'MainDataCostCenter',
    8: 'CompanyBankAccount',
    9: 'Warehouse',
    11: 'Shop',
    13: 'NewSKU',
    17: 'MapleMaterialFactory',
    18: 'FxSellerModule',
    19: 'AlipayAccountConfig',
    20: 'ResearchProject',
    21: 'AmortizationProject',
    22: 'INCI'
  }, // business_type对应docModel

  backPathMap: {
    0: 'skuDetail',
    1: 'spuDetail',
    2: 'productSeriesDetail',
    3: 'brandDetail',
    4: 'materialDetail',
    5: '/customersManagement/customersManagementDetail',
    6: '/basicData/erp/commonForm/departmentListDetail',
    7: '/basicData/erp/commonForm/mainDataCostCenterDetail',
    8: '/finance/MerchantBankAccount/merchantBankAccountDetail',
    9: '/system/WarehouseMasterData/detail',
    11: '/system/ShopManagementMasterData/detail',
    13: 'skuAuthorityDetail',
    17: '/system/skuFactoryRelationshipMasterData/detail',
    18: '/sales/commonList/priceSystem/FxSellerModule',
    19: '/product/commonList/AlipayAccountConfig',
    20: '/finance/researchProject/researchProjectDetail',
    21: '/finance/amortizationProject/amortizationProjectDetail',
    22: '/product/commonList/INCI'
  }, // business_type对应详情backPath
  // 变更单详情页跳转路径
  routerPermissionName: {
    0: 'skuDetail',
    1: 'spuDetail',
    2: 'productSeriesDetail',
    3: 'brandDetail',
    4: 'commonMasterDetail',
    5: 'customersManagementDetail',
    6: 'mainDepartmentListDetail',
    7: 'mainDataCostCenterDetail',
    8: 'merchantBankAccountDetail',
    9: 'warehouseMasterDataDetail',
    11: 'shopManagementMasterDataDetail',
    13: 'skuAuthorityDetail',
    17: 'skuFactoryRelationshipMasterDataDetail',
    18: 'FxSellerModule',
    19: 'AlipayAccountConfigComponent',
    20: 'researchProjectDetail',
    21: 'amortizationProjectDetail',
    22: 'INCI'
  }
}

export const objMasterMap = {
  objName: {
    4: '物料'
  },
  objLog: {
    4: 'product_material_mrp_tbl'
  },
  backPathMasterMap: {
    4: 'materialList'
  } // business_type对应backPath

}
